/* ═══════════════════════════════════════════════════════════
   MensMen España — Theme JS
   Cart drawer, AJAX cart, mobile menu, search, scroll reveal
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  const money = (cents, currency) =>
    (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: currency || window.MM_CURRENCY || 'EUR' });

  /* ─── Cart store ─── */
  const Cart = {
    async get() {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return r.json();
    },
    async add(id, quantity, properties) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: quantity || 1, properties: properties || {} })
      });
      if (!r.ok) throw await r.json();
      return r.json();
    },
    async change(key, quantity) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      return r.json();
    }
  };
  window.MMCart = Cart;

  /* ─── Generic drawer toggling ─── */
  function bindDrawer(drawerId, overlayId) {
    const drawer = document.getElementById(drawerId);
    const overlay = document.getElementById(overlayId);
    if (!drawer || !overlay) return null;
    const open = () => { drawer.classList.add('active'); overlay.classList.add('active'); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.classList.remove('active'); overlay.classList.remove('active'); document.body.style.overflow = ''; };
    overlay.addEventListener('click', close);
    drawer.querySelectorAll('[data-drawer-close]').forEach(b => b.addEventListener('click', close));
    return { open, close, drawer };
  }

  const cartDrawer = bindDrawer('CartDrawer', 'CartOverlay');
  const accountDrawer = bindDrawer('AccountDrawer', 'AccountOverlay');

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      cartDrawer && cartDrawer.close();
      accountDrawer && accountDrawer.close();
      closeSearch();
      document.querySelectorAll('.lightbox.open, .video-modal.open').forEach(m => {
        m.classList.remove('open');
        const v = m.querySelector('video'); if (v) v.pause();
        document.body.style.overflow = '';
      });
    }
  });

  /* ─── Render cart drawer contents ─── */
  const SHIP_THRESHOLD = window.MM_SHIP_THRESHOLD || 0;

  async function renderCart(cart) {
    cart = cart || await Cart.get();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    const body = document.getElementById('CartDrawerBody');
    const foot = document.getElementById('CartDrawerFoot');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><span>Tu carrito está vacío</span></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    let ship = '';
    if (SHIP_THRESHOLD > 0) {
      const pct = Math.min(100, (cart.total_price / SHIP_THRESHOLD) * 100);
      const remaining = SHIP_THRESHOLD - cart.total_price;
      ship = '<div class="ship-bar"><div class="ship-bar-text">' +
        (remaining <= 0 ? '🎉 <strong>¡Tienes envío gratis!</strong>' :
          'Te faltan <strong>' + money(remaining, cart.currency) + '</strong> para el envío gratis') +
        '</div><div class="ship-bar-track"><div class="ship-bar-fill" style="width:' + pct + '%"></div></div></div>';
    }

    const items = cart.items.map(item => {
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="cart-item-variant">' + item.variant_title + '</span>' : '';
      const img = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_160x$1$2') : '';
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<img src="' + img + '" alt="" loading="lazy">' +
        '<div class="cart-item-info">' +
        '<a href="' + item.url + '" class="cart-item-title">' + item.product_title + '</a>' + variant +
        '<div class="cart-item-bottom">' +
        '<div class="cart-item-qty">' +
        '<button data-qty="' + item.key + '" data-to="' + (item.quantity - 1) + '">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button data-qty="' + item.key + '" data-to="' + (item.quantity + 1) + '">+</button>' +
        '</div>' +
        '<span class="cart-item-price">' + money(item.final_line_price, cart.currency) + '</span>' +
        '</div>' +
        '<button class="cart-item-remove" data-qty="' + item.key + '" data-to="0">Eliminar</button>' +
        '</div></div>';
    }).join('');

    body.innerHTML = ship + items;
    const totalEl = document.getElementById('CartDrawerTotal');
    const discRow = document.getElementById('CartDrawerDiscountRow');
    const discEl = document.getElementById('CartDrawerDiscount');
    if (cart.total_discount > 0) {
      const original = cart.original_total_price || (cart.total_price + cart.total_discount);
      if (totalEl) totalEl.innerHTML = '<s style="opacity:.5;font-weight:400;font-size:15px">' + money(original, cart.currency) + '</s> ' + money(cart.total_price, cart.currency);
      if (discRow) discRow.style.display = '';
      if (discEl) discEl.textContent = '−' + money(cart.total_discount, cart.currency);
    } else {
      if (totalEl) totalEl.textContent = money(cart.total_price, cart.currency);
      if (discRow) discRow.style.display = 'none';
    }

    body.querySelectorAll('[data-qty]').forEach(btn => {
      btn.addEventListener('click', async () => {
        body.innerHTML = '<div class="spinner"></div>';
        const cart = await Cart.change(btn.getAttribute('data-qty'), Number(btn.getAttribute('data-to')));
        renderCart(cart);
      });
    });
  }
  window.MMRenderCart = renderCart;

  function openCartDrawer() {
    if (!cartDrawer) return;
    renderCart();
    cartDrawer.open();
  }
  window.MMOpenCart = openCartDrawer;

  /* ─── Intercept add-to-cart globally ─── */
  window.MMAddToCart = async function (id, qty, properties) {
    const cart = await Cart.add(id, qty, properties);
    await renderCart();
    openCartDrawer();
    return cart;
  };

  /* ─── Cart / account icons ─── */
  document.addEventListener('DOMContentLoaded', () => {
    if (cartDrawer && window.MM_CART_DRAWER) {
      document.querySelectorAll('[data-cart-toggle]').forEach(el =>
        el.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); }));
    }
    if (accountDrawer) {
      document.querySelectorAll('[data-account-toggle]').forEach(el =>
        el.addEventListener('click', e => { e.preventDefault(); accountDrawer.open(); }));
    }
    renderCart().catch(() => {});

    // Quick-add buttons (product cards)
    document.querySelectorAll('[data-quick-add]').forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault();
        const id = btn.getAttribute('data-quick-add');
        const label = btn.innerHTML;
        btn.disabled = true; btn.innerHTML = 'Añadiendo…';
        try { await window.MMAddToCart(id, 1); }
        catch (err) { console.error(err); }
        finally { btn.disabled = false; btn.innerHTML = label; }
      });
    });
  });

  /* ─── Mobile menu ─── */
  const menuToggle = document.getElementById('NavToggle');
  const mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    const openM = () => { mobileMenu.classList.add('open'); document.body.style.overflow = 'hidden'; };
    const closeM = () => { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; };
    menuToggle.addEventListener('click', openM);
    mobileMenu.querySelectorAll('[data-menu-close], a').forEach(el => el.addEventListener('click', closeM));
  }

  /* ─── Search modal ─── */
  let searchTimer;
  function closeSearch() {
    const m = document.getElementById('SearchModal');
    if (m) { m.classList.remove('open'); document.body.style.overflow = ''; }
  }
  window.MMCloseSearch = closeSearch;
  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('SearchModal');
    if (!modal) return;
    const input = modal.querySelector('input[type="search"]');
    const results = document.getElementById('SearchResults');
    document.querySelectorAll('[data-search-toggle]').forEach(el =>
      el.addEventListener('click', e => {
        e.preventDefault(); modal.classList.add('open'); document.body.style.overflow = 'hidden';
        setTimeout(() => input && input.focus(), 100);
      }));
    modal.querySelectorAll('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));
    if (input) input.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6');
        const data = await r.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) { results.innerHTML = '<p class="search-empty">No hay resultados para "' + q + '"</p>'; return; }
        results.innerHTML = products.map(p =>
          '<a class="search-result" href="' + p.url + '">' +
          '<img src="' + (p.featured_image ? p.featured_image.url : p.image) + '" alt="" loading="lazy">' +
          '<div><span class="search-result-title">' + p.title + '</span>' +
          '<span class="search-result-price">' + p.price + '</span></div></a>'
        ).join('');
      }, 250);
    });
  });

  /* ─── Scroll reveal ─── */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  });

  /* ─── Lightbox / video modal (shared) ─── */
  window.MMOpenLightbox = function (src) {
    const lb = document.getElementById('Lightbox');
    if (!lb) return;
    lb.querySelector('img').src = src;
    lb.classList.add('open'); document.body.style.overflow = 'hidden';
  };
  window.MMOpenVideo = function (src) {
    const m = document.getElementById('VideoModal');
    if (!m) return;
    const v = m.querySelector('video');
    v.src = src; v.load(); m.classList.add('open'); document.body.style.overflow = 'hidden';
    v.play().catch(() => {});
  };
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.lightbox, .video-modal').forEach(m => {
      m.addEventListener('click', e => {
        if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') return;
        m.classList.remove('open');
        const v = m.querySelector('video'); if (v) v.pause();
        document.body.style.overflow = '';
      });
    });
  });
})();
